// @flow
import React from 'react';
import styled from 'styled-components';
import { FlexRow } from 'styles/Layout';

const ScoreLimits = styled(FlexRow)`
  font-size: ${({ size }) => size}px;
  font-weight: bold;
  justify-content: space-between;
`;

const ScoreBar = styled.div`
  width: 100%;
  height: ${({ height }) => height}px;
  border-radius: ${({ height }) => height / 2}px;
  display: flex;
  overflow: hidden;
  background: #d3d3d2;
`;

const BarSection = styled.div`
  flex: 1;

  &:first-child {
    background: #ff0000;
  }

  &:nth-child(2) {
    background: ${({ failed }) => (failed ? '#ff0000' : '#bdd659')};
  }

  &:nth-child(3) {
    background: ${({ failed }) => (failed ? 'transparent' : '#9dcc60')};
  }

  &:nth-child(4),
  &:nth-child(5) {
    background: ${({ failed }) => (failed ? 'transparent' : '#38be35')};
  }
`;

const ScoreLabels = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: ${({ size }) => size}px;
`;

const ScoreLabel = styled.div`
  flex: 1;
  padding: 8px;
`;

type ScoreRangeBarProps = {
  width?: number,
  barHeight?: number,
  limitsFontSize?: number,
  labelsFontSize?: number,
  style?: any,
  failed?: boolean
};

const ScoreRangeBar = ({
  width = 231,
  barHeight = 8,
  limitsFontSize = 16,
  labelsFontSize = 10,
  failed = false,
  style = {}
}: ScoreRangeBarProps) => {
  return (
    <div style={{ width, ...style }}>
      <ScoreLimits size={limitsFontSize}>
        <div>0</div>
        <div>1500</div>
      </ScoreLimits>
      <ScoreBar height={barHeight}>
        <BarSection failed={failed} />
        <BarSection failed={failed} />
        <BarSection failed={failed} />
        <BarSection failed={failed} />
        <BarSection failed={failed} />
      </ScoreBar>
      <ScoreLabels size={labelsFontSize}>
        <ScoreLabel>Malo</ScoreLabel>
        <ScoreLabel>Medio</ScoreLabel>
        <ScoreLabel>Bueno</ScoreLabel>
        <ScoreLabel>Excelente</ScoreLabel>
      </ScoreLabels>
    </div>
  );
};

export default ScoreRangeBar;
